import moment from 'moment-timezone';

import { DATE_DAILY_SHORT_FORMAT } from '../../constants/date';
import { RETENTION_COLUMN, UNITS_BY_TYPE } from '../../utils/csv';

export const getParamEventsHeader = (info) => {
  const { eventName, groupBy, aggregation, query, timezone } = info;

  const split = info.splitBy > 1 ? `split by ${info.splitBy} ` : ` `;

  const dateFrom = moment.tz(query.globalFilter.from, timezone).format(DATE_DAILY_SHORT_FORMAT);

  const dateTo = moment
    .tz(query.globalFilter.to, timezone)
    .subtract(1, 'days')
    .format(DATE_DAILY_SHORT_FORMAT);

  const joinAggregation = aggregation.join(' ');

  const eventMessage = `${eventName} group by ${groupBy} ${split}aggregate by ${joinAggregation} from ${dateFrom} to ${dateTo} timezone ${query.timezone}`;

  return eventMessage;
};

export const getParamEventsHeaderWithAdditional = (info, additionalPeriods = []) => {
  const { eventName, groupBy, aggregation, query, timezone } = info;

  const split = info.splitBy > 1 ? `split by ${info.splitBy} ` : ` `;

  const dateFrom = moment.tz(query.globalFilter.from, timezone).format(DATE_DAILY_SHORT_FORMAT);

  const dateTo = moment
    .tz(query.globalFilter.to, timezone)
    .subtract(1, 'days')
    .format(DATE_DAILY_SHORT_FORMAT);

  const joinAggregation = aggregation.join(' ');

  const additionalPeriodsToString = additionalPeriods
    .map(
      (additionalPeriod) =>
        `${additionalPeriod.uniqueChar}(${additionalPeriod.from} - ${additionalPeriod.to})`
    )
    .join(' ');

  const eventMessage = `${eventName} group by ${groupBy} ${split}aggregate by ${joinAggregation} from ${dateFrom} to ${dateTo} compare with ${additionalPeriodsToString} timezone ${query.timezone}`;

  return eventMessage;
};

export const getRetentionHeader = ({ sequence }) => {
  return [sequence.type, RETENTION_COLUMN]
    .concat(sequence.units.map((unit) => `${UNITS_BY_TYPE[sequence.type]} ${unit}`))
    .join(';');
};
